<template>
  <div class="is-flex is-flex-direction-column is-align-items-center">
    <import-csv label="Réimport CSV" :format="columns" :loading="false" @submit="submit">
      <template v-if="errorImportMessages.length > 0" #append>
        <div class="control">
          <b-button type="is-danger" icon-left="exclamation-circle" @click="showErrorModal = true">
            {{ errorImportMessages.length }}
          </b-button>
        </div>
      </template>
    </import-csv>

    <b-modal :active="showErrorModal" has-modal-card @close="showErrorModal = false">
      <div class="modal-card">
        <div class="modal-card-head">
          <p class="modal-card-title">Erreurs de ré-importation</p>
        </div>
        <div class="modal-card-body">
          <b-message
            v-for="(error, index) in errorImportMessages"
            :key="index"
            type="is-danger"
            size="is-small"
            class="m-2"
          >
            {{ error }}
          </b-message>
        </div>
        <div class="modal-card-foot">
          <b-button @click="showErrorModal = false">Fermer</b-button>
        </div>
      </div>
    </b-modal>

    <o-modal
      title="Participants inconnus"
      :isOpen="unknownNumbers.length > 0"
      submit-label="Continuer"
      variant="primary"
      @closeModal="cancel"
      @confirmModalAction="reimport"
    >
      <template>
        <div>
          {{ unknownNumbers.length }} dossard(s) n'existent pas et
          <strong>ne seront pas pris en compte</strong> :
        </div>
        <div v-for="number in unknownNumbers" :key="number">- {{ number }}<br /></div>
        <br />
        Seuls les dossards existants seront mis à jour. Continuer ?
      </template>
    </o-modal>
  </div>
</template>

<script>
import { getErrorMessages, reimportLiveVehicleError } from '@helpers/importErrorMessages'
import ImportCsv from '@components/ImportCsv.vue'
import OModal from '@components/Modal.vue'

const COLUMNS = [
  { key: 'line', label: 'line', updatable: false },
  { key: 'number', label: 'number', updatable: false },
  { key: 'name', label: 'name', updatable: true },
  { key: 'accessType', label: 'public/private', updatable: true },
  { key: 'gender', label: 'gender', updatable: true },
  { key: 'country', label: 'country', updatable: true },
  { key: 'phoneNumber', label: 'phone', updatable: true },
  { key: 'comment', label: 'comment', updatable: true },
]

export default {
  name: 'LiveVehicleReimportCsv',

  components: {
    OModal,
    ImportCsv,
  },

  props: {
    live: {
      type: Object,
      required: true,
    },
    liveVehicles: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      errorImportMessages: [],
      showErrorModal: false,
      pendingVehicles: [],
      unknownNumbers: [],
    }
  },

  created() {
    this.columns = Object.fromEntries(COLUMNS.map(({ key, label }) => [key, label]))
    this.updatableColumns = COLUMNS.filter((column) => column.updatable).map((column) => column.key)
  },

  methods: {
    submit({ result }) {
      this.errorImportMessages = []
      this.showErrorModal = false

      if (result.length > 0 && !('number' in result[0])) {
        this.errorImportMessages = ['La colonne « number » est requise.']
        this.$emit('error')
        return
      }

      this.pendingVehicles = result.map((vehicle) => {
        const payload = { number: vehicle.number }
        this.updatableColumns.forEach((key) => {
          if (key in vehicle) {
            payload[key] = vehicle[key] !== '' ? vehicle[key] : null
          }
        })
        return payload
      })

      const existingNumbers = new Set(
        this.liveVehicles.map((vehicle) => vehicle.number.toLowerCase()),
      )
      this.unknownNumbers = this.pendingVehicles
        .filter((vehicle) => !existingNumbers.has(vehicle.number.toLowerCase()))
        .map((vehicle) => vehicle.number)

      if (this.unknownNumbers.length === 0) {
        this.reimport()
      }
    },

    cancel() {
      this.pendingVehicles = []
      this.unknownNumbers = []
    },

    async reimport() {
      this.$emit('submit')

      try {
        const liveVehicles = await this.$services.liveVehicleService.reimportAll(
          this.live.id,
          this.pendingVehicles,
        )

        this.pendingVehicles = []
        this.unknownNumbers = []

        this.$emit('done', liveVehicles)
      } catch (err) {
        this.errorImportMessages = getErrorMessages(err, reimportLiveVehicleError)
        this.$emit('error')
      }
    },
  },
}
</script>
